/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
export const AgentTemplateEnum = core.serialization.enum_(["constraints", "autobuild", "autocast", "webhook-egress", "action-listener", "automap"]);
